export default "__VITE_ASSET__CRX9AQzj__"